/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CallDealerModal_viewer$ref = any;
export type StorefrontCallButton_viewer$ref = any;
export type StorefrontCallButton_viewer = {
    readonly " $fragmentRefs": CallDealerModal_viewer$ref;
    readonly " $refType": StorefrontCallButton_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontCallButton_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "CallDealerModal_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c67b43dc7930e02a0641e35b3ae5393a';
export default node;
